import { hasARoleWithPermission } from "./roleBasedAccess";

const filterReadableFeatures = (features, user) =>
  Object.keys(features).filter(feature =>
    hasARoleWithPermission(user?.role, features?.[feature]?.roles)
  );

export default filterReadableFeatures;
